import React from 'react';
import classNames from 'classnames';
import Base from '@ignitesales/neuro-application/src/components/questions/containers/Base';

const SubGroup = (props) => {
  const {
    className,
    ...rest
  } = props;

  const classes = classNames(
    className,
    'questionGroup--subGroup'
  );

  return <Base className={ classes } { ...rest } />;
};

export default SubGroup;
